var map = {
	"./3.png": "5f07",
	"./alltele.png": "0d8a",
	"./bahnhof.png": "e6cc",
	"./boxerlogo.png": "3e97",
	"./bredband2.png": "c9fc",
	"./net1.png": "87d6",
	"./netatonce.png": "5510",
	"./quicknet.png": "8d53",
	"./starlink.png": "105d",
	"./tele2.png": "03fc",
	"./telenor.png": "e94a",
	"./telia.png": "f6c0",
	"./universal.png": "380b",
	"./viasat.png": "9a16"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "69ae";